import { render, staticRenderFns } from "./FileComponent.vue?vue&type=template&id=4bc67c30&scoped=true"
import script from "./FileComponent.vue?vue&type=script&lang=js"
export * from "./FileComponent.vue?vue&type=script&lang=js"
import style0 from "./FileComponent.vue?vue&type=style&index=0&id=4bc67c30&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bc67c30",
  null
  
)

export default component.exports